var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoutes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2503_10620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58329 4.42969H9.94529C12.4847 4.42969 13.7543 4.42969 14.2363 4.88576C14.6529 5.27999 14.8376 5.86076 14.7251 6.4232C14.595 7.07387 13.5584 7.80707 11.4852 9.27346L8.09806 11.6692C6.02488 13.1356 4.98828 13.8688 4.85816 14.5195C4.74567 15.082 4.93031 15.6627 5.34693 16.0569C5.82891 16.513 7.09859 16.513 9.63796 16.513H10.4166M6.66663 4.42969C6.66663 5.8104 5.54734 6.92969 4.16663 6.92969C2.78591 6.92969 1.66663 5.8104 1.66663 4.42969C1.66663 3.04898 2.78591 1.92969 4.16663 1.92969C5.54734 1.92969 6.66663 3.04898 6.66663 4.42969ZM18.3333 16.0964C18.3333 17.4771 17.214 18.5964 15.8333 18.5964C14.4526 18.5964 13.3333 17.4771 13.3333 16.0964C13.3333 14.7156 14.4526 13.5964 15.8333 13.5964C17.214 13.5964 18.3333 14.7156 18.3333 16.0964Z",
    stroke: "#667185",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2503_10620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.263062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutes);
export default __webpack_public_path__ + "static/media/routes.9b806a5faa1d24ca92cc417db92ec4bf.svg";
export { ForwardRef as ReactComponent };